import { type Size as IconSize } from '@atoms/BasicIcon/sizes';

export const tags = ['button', 'a'] as const;
export type Tag = (typeof tags)[number];

export const typeAttributes = ['button', 'submit', 'reset'] as const;
export type TypeAttribut = (typeof typeAttributes)[number];

export const targetAttributes = ['_self', '_blank', '_parent', '_top'] as const;
export type TargetAttribut = (typeof targetAttributes)[number];

export type ColorsConfig = {
    bg: string;
    bgHover: string;
    text: string;
    textLink: string;
    textHover: string;
    fill: string;
    fillLink: string;
    fillHover: string;
};
export const colors = {
    primary: {
        bg: 'bg-primary',
        bgHover: 'hover:bg-primary-hover',
        text: 'text-font-4',
        textLink: 'text-primary',
        textHover: 'hover:text-primary-hover',
        fill: 'fill-font-4',
        fillLink: 'fill-primary',
        fillHover: 'group-hover:fill-primary-hover',
    },
    secondary: {
        bg: 'bg-secondary',
        bgHover: 'hover:bg-secondary-hover',
        text: 'text-font-4',
        textLink: 'text-secondary',
        textHover: 'hover:text-secondary-hover',
        fill: 'fill-secondary',
        fillLink: 'fill-secondary',
        fillHover: 'group-hover:fill-secondary-hover',
    },
    info: {
        bg: 'bg-info',
        bgHover: 'hover:bg-info-hover',
        text: 'text-font-4',
        textLink: 'text-info',
        textHover: 'hover:text-info-hover',
        fill: 'fill-font-4',
        fillLink: 'fill-info',
        fillHover: 'group-hover:fill-info-hover',
    },
    error: {
        bg: 'bg-error',
        bgHover: 'hover:bg-error-hover',
        text: 'text-font-4',
        textLink: 'text-error',
        textHover: 'hover:text-error-hover',
        fill: 'fill-font-4',
        fillLink: 'fill-error',
        fillHover: 'group-hover:fill-error-hover',
    },
    white: {
        bg: 'bg-white',
        bgHover: 'hover:bg-white-hover',
        text: 'text-font-1',
        textLink: 'text-white',
        textHover: 'hover:text-font-1',
        fill: 'fill-font-1',
        fillLink: 'fill-white',
        fillHover: 'group-hover:fill-font-1',
    },
    transparent: {
        bg: 'bg-transparent',
        bgHover: 'hover:bg-white',
        text: 'text-font-1',
        textLink: 'text-font-1',
        textHover: 'hover:text-font-1',
        fill: 'fill-font-1',
        fillLink: 'fill-font-1',
        fillHover: 'group-hover:fill-font-1',
    },
    transparentGrey: {
        bg: 'bg-transparent',
        bgHover: 'hover:bg-background-2',
        text: 'text-font-3',
        textLink: 'text-font-3',
        textHover: 'hover:bg-white-hover',
        fill: 'fill-font-3',
        fillLink: 'fill-font-3',
        fillHover: 'group-hover:fill-font-3',
    },
} as const satisfies Readonly<Record<string, ColorsConfig>>;
export type Color = keyof typeof colors;

export const widths = ['w-none', 'w-full', 'min-w-135'] as const;
export type Width = (typeof widths)[number];
export const widthClasses: Record<Width, string> = {
    'w-none': 'w-none',
    'w-full': 'w-full',
    'min-w-135': 'min-w-[135px]',
};

export const sizes = ['sm', 'm', 'lg'] as const;
export type Size = (typeof sizes)[number];

export const sizeClasses: Record<Size, string> = {
    sm: 'px-[8px] py-[3px] text-[10px] leading-[10px]',
    m: 'px-[15px] py-[8px] text-[12px] leading-[12px]',
    lg: 'px-[20px] py-[12px] text-[14px] leading-[14px]',
};

export const sizeRelatedContentHolderClasses: Record<Size, string> = {
    sm: '',
    m: '',
    lg: 'py-[3px]',
};

export const sizeRelatedTextHolderClasses: Record<Size, string> = {
    sm: '',
    m: 'py-[1px]',
    lg: '',
};

export const sizeCircleClasses: Record<Size, string> = {
    sm: 'w-[16px] h-[16px]',
    m: 'w-[30px] h-[30px]',
    lg: 'w-[44px] h-[44px]',
};

export const iconSizes: Record<Size, IconSize> = {
    sm: '8',
    m: '14',
    lg: '14',
};
